import React from "react"
import { CustomersFilterData } from "../customersActions"
import { Forms } from "../../common/components/CmForms"
import { TipoCombustibileSelector } from "../../tipiCombustilbile/components/tipoCombustibileSelector";
import { AccordionItem } from "../../common/accordion";
import StringsHelper from "../../common/stringsHelper";
const { Form, FormText, Submit, FormCheck, FormInteger } = Forms<CustomersFilterData>();
interface Props {
    initialData: CustomersFilterData;
    onSubmit: (data: CustomersFilterData) => void;
}
export const CustomersFilter = (props: Props) => <Form
    initialValues={props.initialData}
    onSubmit={props.onSubmit}
    noPrompt
>
    {({ set, values }) => {
        const hasAdvancedFilter = values.codClienteAzienda != undefined
            || !StringsHelper.isNullOrWhiteSpace(values.filtroCaldaia)
            || !StringsHelper.isNullOrWhiteSpace(values.filtroContatto)
            || !StringsHelper.isNullOrWhiteSpace(values.filtroLocalita)
            || !StringsHelper.isNullOrWhiteSpace(values.filtroCombustibile)
            || !StringsHelper.isNullOrWhiteSpace(values.filtroCaldaia);
        return <div className="mb-3 d-print-none">
            <FormText
                label="Nominativo"
                name="filtroNominativo"
            />
            <AccordionItem
                open={hasAdvancedFilter}
                heading={<div className="w-100 text-info text-end">
                    Ricerca avanzata <i className="fas fa-search-plus fa-lg ms-2" />
                </div>}>
                <div className="row d-flex align-items-center">
                    <div className="col-12 col-md">
                        <FormInteger
                            label="Codice"
                            name="codClienteAzienda"
                        />
                    </div>
                    <div className="col-12 col-md">
                        <FormText
                            label="Comune\Frazione\Indirizzo"
                            name="filtroLocalita"
                        />
                    </div>
                    <div className="col-12 col-md">
                        <FormText
                            label="Tel\Cell\Email"
                            name="filtroContatto"
                        />
                    </div>
                    <div className="w-100" />
                    <div className="col-12 col-md">
                        <FormText
                            label="Caldaia (Marca\Modello\Matricola)"
                            name="filtroCaldaia"
                        />
                    </div>
                    <div className="col-12 col-md">
                        <TipoCombustibileSelector
                            label="Caldaia (Combustibile)"
                            value={values.filtroCombustibile ?? null}
                            onChange={value => set("filtroCombustibile", value ?? "")}
                        />
                    </div>
                    <div className="col-12 col-md">
                        <FormText
                            label="Pod\Pdr\Targa"
                            name="filtroPodCatasto"
                        />
                    </div>
                    <div className="col-12">
                        <FormCheck
                            label="Considera anagrafiche dismesse"
                            name="viewAnagDismesse"
                        />
                    </div>
                </div>
            </AccordionItem>
            <Submit alwaysActive><i className="fa fa-search" /> Cerca</Submit>
        </div>
    }
    }
</Form >
